<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/child'
import PageHeader from '@components/page-header'

import TestimonialsForm from './TestimonialsForm';
import { CommunicationsTable } from 'coryallen-communications';

export default {
  page: {
    title: 'Testimonials',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader, TestimonialsForm, CommunicationsTable },
  data() {
    return {
      title: 'Testimonials',
      items: [
        { text: appConfig.title, to: '/', },
        { text: 'Testimonials', to: '/testimonials', },
        { text: '', active: true, },
      ],
      dsbl_btn: false,

      tabIndex: 0,

      loading: true,
      item: [],
      filters: {
        paginate: 1,
        page: 1,
        total: 0,
        getmapping: 'yes',
        wheres: {
          id: this.$route.params.id
        },
      },

      communications_loading: true,
      communications_filters: {
        paginate: 50,
        page: 1,
        total: 0,
        types: ['Note', 'Activity'],
        only: '',
        onable_id: this.$route.params.id,
        onable_type: 'coryallen\\Testimonials\\Models\\Testimonial',
        /* byable_id: '1',
        byable_type: 'App\\User', */
      },

    }
  },
  created() {
    this.tabIndex = parseInt(window.location.hash.replace('#',''), 10);
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      this.$http.get('/api/testimonials/fetch', {params: this.filters}).then(res => {
        // console.log(res);
        if(res.data.data.length == 1) {
          this.item = res.data.data[0];
          this.title = this.items[2].text = this.item.posted_by;
        } else {
          $this.$noty.warning("Content could not be found.");
          this.$router.push('/testimonials');
        }
        this.loading = false;
      }).catch(res => { this.popupErrors(res); this.loading = false; });
    },
    update_testimonial() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;

      this.$http.put('/api/testimonials/update', this.item).then(res => {
        // console.log(res);
        this.$noty.success("Changes have been saved");
        this.dsbl_btn = false;
      }).catch(res => { this.popupErrors(res); this.dsbl_btn = false; });
    },
    delete_testimonial() {
      if(this.dsbl_btn == true) { this.$noty.warning('Disabled'); return; } this.dsbl_btn = true;
      if(!this.item.id) { this.$noty.warning('ID not found'); this.dsbl_btn = false; return; }
      let randomid = 'id'+(Math.random() + 1).toString(36).substring(7);
      var n = new Noty({
        timeout: false,
        modal: true,
        type: 'alert', // alert, success, warning, error, info
        layout: 'center', // top, topLeft, topCenter, topRight, center, centerLeft, centerRight, bottom, bottomLeft, bottomCenter, bottomRight
        closeWith: ['button'], // click, button
        text: "Are you sure you want to delete this testimonial?",
        buttons: [
          Noty.button('<span id="'+randomid+'_spin" class="d-none spinner-border spinner-border-sm"></span> YES', 'btn btn-danger px-4 float-right ml-2', notyres => {
            var btn = document.getElementById(randomid), spin = document.getElementById(randomid+"_spin"), btnno = document.getElementById(randomid+"_no");
            if(btn.disabled) { this.$noty.warning('Disabled'); return; } btn.disabled = btnno.disabled = true; spin.classList.remove("d-none");
            this.$http.delete('/api/testimonials/delete/'+this.item.id, this.item).then(res => {
              // console.log(res);
              this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none");
              this.$router.push('/testimonials');
              n.close();
            }).catch(res => { this.popupErrors(res); this.dsbl_btn = btn.disabled = btnno.disabled = false; spin.classList.add("d-none"); });
          }, {id: randomid, 'data-status': 'ok'}),
          Noty.button('CANCEL', 'btn btn-light px-4 mr-2', notyres => {
            n.close();
          }, {id: randomid+'_no', 'data-status': 'ok'}),
        ]
      }).show().on('onClose', () => { this.dsbl_btn = false; });
    },
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <b-tabs class="nav-bordered header-nav hide-content" lazy v-model="tabIndex">
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="loading"></span> Details</template></b-tab>
      <b-tab><template v-slot:title><span class="spinner-border spinner-border-sm" v-if="communications_loading"></span> Notes & Activities</template></b-tab>
    </b-tabs>

    <div v-if="item.id">

      <div class="row mt-4">
        <div class="col-sm-5">

          <div class="card-box border p-0 _box-shadow-0-1-4-b-2" data-aos="fade-zoom-in">
            <div class="row m-0">
              <div class="_w-70 pt-4 pl-4">
                <img v-if="item.thumbnail" :src="formatImage(item.thumbnail)" class="_w-50 rounded-circle">
                <avatar v-else :username="item.posted_by" :size="50" class="mx-auto"></avatar>
              </div>
              <div class="col-12 col-sm pt-4 pr-4">
                <div class="float-right text-right">
                  <div class="text-warning _f-s-30 _lh-30">
                    <span v-for="index in 5" :key="index">
                      <Icon v-if="item.stars >= index" icon="ri:star-fill" class="_svg-shadow-2-2-1-b-2"></Icon>
                      <Icon v-else icon="ri:star-line" class="_svg-shadow-2-2-1-b-2"></Icon>
                    </span>
                  </div>
                  <small class="text-muted">{{item['stars']}}/5 stars</small>
                </div>
                <div class="d-inline-block">
                  <h5 class="mb-0">{{item['posted_by']}}</h5>
                  <small class="text-muted">{{item['posted_on']}}</small>
                </div>
              </div>
              <div class="col-12 p-4">
                <div v-html="item.content"></div>
              </div>
            </div>
          </div>

          <div class="card-box">
            <h5 class="section-header mb-3"><Icon icon="ri:book-2-line"></Icon> About :</h5>
            <div class="table-responsive">
              <table class="table table-sm table-px-0">
                <tbody>
                  <tr><th class="border-0"><label>Website :</label></th><td class="border-0 small">{{item.website}}</td></tr>
                  <tr><th><label>Updated on :</label></th><td class="small" v-tippy :content="moment(item.updated_at).format('lll')">{{moment(item.updated_at).fromNow()}}</td></tr>
                  <tr><th><label>Created on :</label></th><td class="small" v-tippy :content="moment(item.created_at).format('lll')">{{moment(item.created_at).fromNow()}}</td></tr>
                </tbody>
              </table>
            </div>
          </div>
          <button type="button" class="btn btn-block btn-outline-danger" @click="delete_testimonial" :disabled="dsbl_btn"><Icon icon="ri:delete-bin-7-line" /> Delete Testimonial</button>

        </div>
        <div class="col-sm-7">

          <div v-show="tabIndex == 0">
            <div class="card-box">
              <b-form @submit.prevent="update_testimonial">
                <TestimonialsForm :item="item"></TestimonialsForm>
                <div class="border-top border-light mt-5 pt-3 text-right">
                  <button type="submit" class="btn btn-success ml-3" :disabled="dsbl_btn"><span v-if="dsbl_btn" class="spinner-border spinner-border-sm"></span><Icon v-else icon="ri:save-line" /> Save</button>
                  <div class="clearfix"></div>
                </div>
              </b-form>
            </div>
          </div>

          <div v-show="tabIndex == 1">
            <div class="">
              <CommunicationsTable ref="CommunicationsTable" :filters="communications_filters" :user="user" :name="'title'" @loadchange="(e) => {communications_loading = e}"></CommunicationsTable>
            </div>
          </div>

        </div>
      </div>

    </div>
  </Layout>
</template>
